import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { Layout, Title, Pagination } from 'common/components/layout';
import {
  urlPushQuery,
  concatUrlString,
  queryStringFromProps,
  pageFromQuery
} from 'common/helpers/searchHelper';
import SubMenu from 'profile/common/SubMenu';
import {
  resetLoyaltyTransactionQuery,
  listLoyaltyTransactions
} from 'redux/loyaltyTransactions/actions';

import LoyaltyTransactionList from './components/LoyaltyTransactionList';

const LoyaltyPoints = (props) => {
  const urlString = queryStringFromProps(props);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    dispatch(resetLoyaltyTransactionQuery());
    dispatch(listLoyaltyTransactions(urlString));
  }, [dispatch, urlString]);

  const search = (page) => {
    dispatch(resetLoyaltyTransactionQuery());
    const newUrlString = concatUrlString(page);
    dispatch(listLoyaltyTransactions(newUrlString));
    history.push(urlPushQuery('/profile/loyalty-transaction', newUrlString));
  };

  const page = pageFromQuery(location.search);

  const settings = useSelector((state) => state.setting.data);
  const loyaltyTransactionReducer = useSelector(
    (state) => state.loyaltyTransaction
  );
  const customer = useSelector((state) => state.customer.data);

  if (
    !settings ||
    !customer ||
    !loyaltyTransactionReducer.data ||
    loyaltyTransactionReducer.query === null
  ) {
    return (
      <Layout title="Loyalty Points" loading>
        <Title>Your Account</Title>
        <SubMenu />
      </Layout>
    );
  }

  return (
    <Layout title="Loyalty Points">
      <Title>Your Account</Title>
      <SubMenu />
      <div className="c7-account__order-history">
        <h2>Loyalty Points</h2>
        <div>
          <h3>
            <Tier customer={customer} />
            {customer?.loyalty?.points || 0} Points
          </h3>
          <br />
        </div>
        <LoyaltyTransactionList />
        <Pagination
          totalRecords={loyaltyTransactionReducer.recordCount}
          page={page || 1}
          search={search}
        />
      </div>
    </Layout>
  );
};

const Tier = (props) => {
  const { customer } = props;
  if (customer?.loyalty?.tier) {
    return (
      <>
        Tier: {customer.loyalty.tier}
        <br />
      </>
    );
  }
  return null;
};

export default LoyaltyPoints;
